var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreementIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.348 9.07682L9.65745 14.8789L15.348 20.681L16.2674 19.7435L12.1605 15.5456H23V14.2122H12.1605L16.2674 10.0143L15.348 9.07682ZM11.2308 4.87891H6V24.8789H11.2308V23.5456H7.30769V6.21224H11.2308V4.87891Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.348 8.57682C15.2137 8.57682 15.085 8.63084 14.991 8.72672L9.30048 14.5288C9.10978 14.7232 9.10978 15.0346 9.30048 15.229L14.991 21.0311C15.085 21.127 15.2137 21.181 15.348 21.181C15.4822 21.181 15.6109 21.127 15.7049 21.0311L16.6244 20.0936C16.8149 19.8993 16.8151 19.5883 16.6248 19.3938L13.3491 16.0456H23C23.2761 16.0456 23.5 15.8217 23.5 15.5456V14.2122C23.5 13.9361 23.2761 13.7122 23 13.7122H13.3491L16.6248 10.364C16.8151 10.1695 16.8149 9.85849 16.6244 9.66422L15.7049 8.72672C15.6109 8.63084 15.4822 8.57682 15.348 8.57682ZM12.1605 14.2122H23V15.5456H12.1605L16.2674 19.7435L15.348 20.681L9.65745 14.8789L15.348 9.07682L16.2674 10.0143L12.1605 14.2122ZM11.7308 4.87891C11.7308 4.60276 11.5069 4.37891 11.2308 4.37891H6C5.72386 4.37891 5.5 4.60276 5.5 4.87891V24.8789C5.5 25.155 5.72386 25.3789 6 25.3789H11.2308C11.5069 25.3789 11.7308 25.155 11.7308 24.8789V23.5456C11.7308 23.2694 11.5069 23.0456 11.2308 23.0456H7.80769V6.71224H11.2308C11.5069 6.71224 11.7308 6.48838 11.7308 6.21224V4.87891ZM7.30769 6.21224V23.5456H11.2308V24.8789H6V4.87891H11.2308V6.21224H7.30769Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementIa);
export default __webpack_public_path__ + "static/media/agreementIA.6fa3e268867ce6db0a91c375e2b52c31.svg";
export { ForwardRef as ReactComponent };